import axios from '@axios';
import useJwt from '@/auth/jwt/useJwt';

const userTokenKey = 'userTokenOffsite'; // changed keys as they clashed with portal names locally (used in router also)
const userKey = 'userOffsite';
export default {
  namespaced: true,
  state: {
    user: null,
    expiry: null,
    intakeVisitId: null,
  },
  getters: {
    getLocalUser() {
      return JSON.parse(localStorage.getItem(userKey));
    },
    getLocalUserToken() {
      return localStorage.getItem(userTokenKey);
    },
    isIntakeUser() {
      const expiry = localStorage.getItem(useJwt.jwtConfig.storageExpiryName);
      return !!expiry;
    },
    intakeVisitId() {
      return localStorage.getItem(useJwt.jwtConfig.storageIntakeVisitId);
    },
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_EXPIRY(state, expiry) {
      state.expiry = expiry;
    },
    SET_INTAKE_VISIT_ID(state, visitId) {
      state.intakeVisitId = visitId;
    },
  },
  actions: {
    // eslint-disable-next-line
    clearLocalUser({ commit }) {
      localStorage.removeItem(userTokenKey);
      localStorage.removeItem(userKey);
      localStorage.removeItem(useJwt.jwtConfig.storageExpiryName)
      localStorage.removeItem(useJwt.jwtConfig.storageIntakeVisitId)
      axios.defaults.headers.common.Authorization = null;
    },
    // eslint-disable-next-line
    setLocalUser({ commit }, user) {
      localStorage.setItem(userKey, JSON.stringify(user));
      commit('SET_USER', user);
    },
    // eslint-disable-next-line
    setLocalUserToken({ commit }, token) {
      localStorage.setItem(userTokenKey, token);
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    },
    setCurrentUserFromLocalStorage({ commit }) {
      const user = localStorage.getItem(userKey);
      const tokenExpiry = localStorage.getItem(useJwt.jwtConfig.storageExpiryName);
      const intakeVisitId = localStorage.getItem(useJwt.jwtConfig.storageIntakeVisitId);

      if (user) {
        commit('SET_USER', JSON.parse(user));
      }
      if (tokenExpiry) {
        commit('SET_EXPIRY', new Date(tokenExpiry));
      }
      if (intakeVisitId) {
        commit('SET_INTAKE_VISIT_ID', intakeVisitId);
      }
    },
  },
};
